<template>
  <modal
    name="edit-department-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Edit Department</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Department Name</label
            >
          
             <input
                type="text"
                class="textInputField"
                placeholder="Enter department name"
                v-model="department_name"
              />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        
        <ButtonWithSpinner
            class="button button--primary button--sm mr-3"
            @click="updateDepartment()"
            :disabled="button.disabled"
            :loading="button.loading"
            :success="button.success"
        >
          Update</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>

import ButtonWithSpinner from "@/components/Button";
//import Toggle from "@/components/toggle";
export default {
  name: "EditDepartment",
  components: {
    // AppToggle: Toggle,
    ButtonWithSpinner,
  },
  data() {
    return {
      //value: null,
      //options: ["list", "of", "options"],
      //unlimited_validaiton: true,
      department_name: "",
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
    };
  },
  computed: {
  },
  created() {},
  methods: {
    getData(e){
        this.department_id   =e.params.department.department_id;
        this.department_name = e.params.department.department_name;
    },
    closeModal() {
      this.$modal.hide("edit-department-modal");
    },
    resetData(){
      this.department_name = "";
      this.button = {
        loading: false,
        success: false,
        disabled: false,
      };
    },
    updateDepartment(){
     
     if (this.department_name == "") {
        this.$toasted.show("Please enter department name!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.formData = new FormData();

      this.formData.append("department_name", this.department_name);
      this.formData.append("id", this.department_id);

      this.button.disabled = true;
      this.button.loading = true;

      this.axios
        .post(window.hostname + "api/auth/departments/update", this.formData)
        .then((res) => {
          if (res.data.status) {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = true;
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.$emit("update_department", true);
            this.resetData();
            this.closeModal();
          } else {
            this.button.disabled = false;
            this.button.loading = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    }


    },  
  };

</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
</style>